<span class="icon icon-{{ icon }}" [ngClass]="{'esir': esir}"
    [ngStyle]="{ 'font-size': size, width: size, height: size }"></span>